import React from 'react';
import './Avatar.css'; // Assurez-vous d'ajouter des styles si nécessaire

const Avatar = ({ firstname, lastname }) => {
    const initials = `${firstname.charAt(0).toUpperCase()}${lastname.charAt(0).toUpperCase()}`;
    
    return (
        <div className="avatar">
            {initials}
        </div>
    );
};

export default Avatar;
